export default __webpack_public_path__ + "static/media/fpa60030.131740ea.png";